import { render, staticRenderFns } from "./EditarEnviosSM.vue?vue&type=template&id=2a9cb320"
import script from "./EditarEnviosSM.vue?vue&type=script&lang=ts"
export * from "./EditarEnviosSM.vue?vue&type=script&lang=ts"
import style0 from "./EditarEnviosSM.vue?vue&type=style&index=0&id=2a9cb320&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports